export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 comic-dot-pattern" aria-labelledby="testimonial-title">
      <div className="max-w-[1200px] mx-auto">
        <div className="mb-10">
          <p className="text-comic-accent text-xs font-medium tracking-widest mb-3">READER REVIEWS</p>
          <h2 id="testimonial-title" className="text-3xl md:text-5xl font-black text-white">
            漫迷<span className="text-comic-primary">口碑</span>
          </h2>
        </div>

        <div className="flex flex-col gap-8">
          {/* 评价1 */}
          <article className="bg-[#06060A] rounded-3xl p-6 md:p-10 flex flex-col lg:flex-row gap-6 lg:gap-10 items-start relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-full speed-line opacity-30 pointer-events-none"></div>
            <div className="flex-shrink-0 relative z-10">
              <div className="w-20 h-20 md:w-24 md:h-24 rounded-2xl overflow-hidden -ml-2 lg:-ml-6 border-2 border-comic-accent/30">
                <img
                  src="https://readdy.ai/api/search-image?query=Anime%20style%20young%20male%20character%20portrait%20avatar%2C%20stylish%20casual%20look%2C%20soft%20warm%20lighting%2C%20neutral%20gray%20background%2C%20clean%20illustration%20style%2C%20square%20format&width=300&height=300&seq=avatar-user-1&orientation=squarish"
                  alt="漫画控小明"
                  title="漫画控小明 - 韩国漫画网用户"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
            <div className="flex-1 relative z-10">
              <div className="text-comic-accent/20 text-6xl md:text-8xl font-serif leading-none mb-2">&ldquo;</div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed -mt-6 mb-6">
                从大学开始就在韩漫网看漫画了，五年老用户！更新速度真的快，画质也是一流。最爱的《我独自升级》就是在这里追完的，强烈推荐给所有韩漫爱好者！界面干净整洁，完全没有烦人的弹窗广告，阅读体验超棒。
              </p>
              <div className="flex items-center gap-3">
                <div>
                  <p className="text-white font-bold text-sm">漫画控小明</p>
                  <p className="text-gray-500 text-xs">VIP会员</p>
                </div>
              </div>
            </div>
          </article>

          {/* 评价2 */}
          <article className="bg-[#06060A] rounded-3xl p-6 md:p-10 flex flex-col lg:flex-row gap-6 lg:gap-10 items-start relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-full speed-line opacity-30 pointer-events-none"></div>
            <div className="flex-shrink-0 relative z-10">
              <div className="w-20 h-20 md:w-24 md:h-24 rounded-2xl overflow-hidden -ml-2 lg:-ml-6 border-2 border-comic-accent/30">
                <img
                  src="https://readdy.ai/api/search-image?query=Anime%20style%20young%20female%20character%20portrait%20avatar%2C%20cute%20casual%20look%2C%20soft%20warm%20lighting%2C%20neutral%20gray%20background%2C%20clean%20illustration%20style%2C%20square%20format&width=300&height=300&seq=avatar-user-2&orientation=squarish"
                  alt="二次元少女"
                  title="二次元少女 - 韩国漫画网用户"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
            <div className="flex-1 relative z-10">
              <div className="text-comic-accent/20 text-6xl md:text-8xl font-serif leading-none mb-2">&ldquo;</div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed -mt-6 mb-6">
                韩漫网的分类特别细致，找漫画超方便！校园恋爱类是我的最爱，每天都要上来看看有没有更新。而且免费作品真的很多，不用花钱就能看到大量优质内容。朋友推荐来的，现在我也成了忠实用户！
              </p>
              <div className="flex items-center gap-3">
                <div>
                  <p className="text-white font-bold text-sm">二次元少女</p>
                  <p className="text-gray-500 text-xs">黄金会员</p>
                </div>
              </div>
            </div>
          </article>

          {/* 评价3 */}
          <article className="bg-[#06060A] rounded-3xl p-6 md:p-10 flex flex-col lg:flex-row gap-6 lg:gap-10 items-start relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-full speed-line opacity-30 pointer-events-none"></div>
            <div className="flex-shrink-0 relative z-10">
              <div className="w-20 h-20 md:w-24 md:h-24 rounded-2xl overflow-hidden -ml-2 lg:-ml-6 border-2 border-comic-accent/30">
                <img
                  src="https://readdy.ai/api/search-image?query=Anime%20style%20mature%20male%20character%20portrait%20avatar%2C%20experienced%20look%2C%20soft%20warm%20lighting%2C%20neutral%20gray%20background%2C%20clean%20illustration%20style%2C%20square%20format&width=300&height=300&seq=avatar-user-3&orientation=squarish"
                  alt="资深漫迷老张"
                  title="资深漫迷老张 - 韩国漫画网用户"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
            <div className="flex-1 relative z-10">
              <div className="text-comic-accent/20 text-6xl md:text-8xl font-serif leading-none mb-2">&ldquo;</div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed -mt-6 mb-6">
                作为一个看了二十年漫画的老漫迷，韩漫网是我见过最专业的韩漫平台。收录作品非常全，很多冷门佳作都能找到。高清画质对手机阅读特别友好，加载速度也很快，强烈安利！
              </p>
              <div className="flex items-center gap-3">
                <div>
                  <p className="text-white font-bold text-sm">资深漫迷老张</p>
                  <p className="text-gray-500 text-xs">钻石会员</p>
                </div>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}